export default {
  navContainer: {
    width: '100%',
    maxWidth: '300px',
  },
  navCompleted: {
    backgroundColor: '#000',
  },
};
